import React, { useState, useRef, useEffect } from "react";
import "../../../../style/components/whatsAppPreview.css";
import { bg_whatsapp, whatsapp_brand } from "../../../../images/WhatsAppImages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faGlobe, faGift } from "@fortawesome/free-solid-svg-icons";
import styles from './WhatsappPreview.module.css'
function WhatsAppPreview(props) {
  let previewData = props.previewData;
  let route = props.route
  

  const scrollRef = useRef(null);
  const isDown = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    const handleMouseDown = (e) => {
      isDown.current = true;
      startX.current = e.pageX - container.offsetLeft;
      scrollLeft.current = container.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown.current = false;
    };

    const handleMouseUp = () => {
      isDown.current = false;
    };

    const handleMouseMove = (e) => {
      if (!isDown.current) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX.current) * 1.5; // scroll speed
      container.scrollLeft = scrollLeft.current - walk;
    };

    container.addEventListener("mousedown", handleMouseDown);
    container.addEventListener("mouseleave", handleMouseLeave);
    container.addEventListener("mouseup", handleMouseUp);
    container.addEventListener("mousemove", handleMouseMove);

    return () => {
      container.removeEventListener("mousedown", handleMouseDown);
      container.removeEventListener("mouseleave", handleMouseLeave);
      container.removeEventListener("mouseup", handleMouseUp);
      container.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const companyname = localStorage.getItem("wp-cmpy-name");
  var truncatedcompanyname;
  if (companyname) {
    if (companyname.length <= 15) {
      truncatedcompanyname = companyname
    } else {
      truncatedcompanyname = companyname.substring(0, 15) + '...';
    }
  }
  const companyimg = localStorage.getItem("wp-cmpy-img");

  const displayWhatsAppPreview = (TemplateType, headerText) => {
    for (let key in headerText) {
      if (key === "text") {
        return <strong> {previewData.headerText.text} </strong>;
      }
      if (key === "image") {
        return <img className="img-fluid" src={previewData.headerText.image} />;
      }
      if (key === "video") {
        return (
          <video width="100%" controls>
            <source src={previewData.headerText.video} type="video/mp4" />
          </video>
        );
      }
      if (key === "document") {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={previewData.headerText.document}
          >
            <div className="doc-type">Document Media</div>
          </a>
        );
      }
    }
  };


  const quickReply = () => {
    return previewData.quickButton.map((item) => {
      let key = Object.keys(item);
      const index = key.indexOf("actionType");
      if (index > -1) {
        let data = key.splice(index, 1);
      }

      return key.map((keyitem) => (
        <div className="button-text">
          <p className="mb-1">{item[keyitem]}</p>
        </div>
      ));
    });
  };

  const getButtonQuickReplies = () => {
    const buttons = [];
    for (let i = 1; i <= 7; i++) {
      const btn = previewData[`button${i}`];
      if (btn && btn.actionType === "quickReply") {
        const textKey = Object.keys(btn).find(k => k !== "actionType");
        if (textKey) buttons.push(btn[textKey]);
      }
    }
    return buttons;
  };

  console.log(previewData);
  

  return (
    <div className="whatsapp">
      {previewData && previewData.templateType !== "Carousel" && (
        <>
          <ul>
            <li>
              {" "}
              <strong> Template name: </strong> {previewData.tampleName}{" "}
            </li>
            <li>
              <strong> Language: </strong> {previewData.language.label}{" "}
            </li>
            <li>
              {" "}
              <strong> Category: </strong>
              {previewData.accountType}{" "}
            </li>
            <li>
              {" "}
              <strong> Type: </strong> {previewData.templateType}{" "}
            </li>
          </ul>
          <div
            style={{ backgroundImage: `url(${bg_whatsapp})` }}
            className="whatsapp-review whatsapp-bg"
          >
            <div>
              <div className="text-section">
                <div className="whats-app-header">
                  <div className="">
                    {" "}
                    {/* <img src={companyimg ? companyimg : whatsapp_brand} />{" "} */}
                  </div>
                  <div className="">
                    {" "}
                    <p>{truncatedcompanyname} </p>{" "}
                  </div>
                </div>

                <div className="body-message">
                  {displayWhatsAppPreview(
                    previewData?.headerText?.TemplateType,
                    previewData?.headerText
                  )}
                  <img src={previewData?.headerText?.tempImage} className="img-fluid" />
                  <p>
                    {" "}
                    {previewData.bodyMessage}
                  </p>

                  <small>{previewData.footerText}</small>
                </div>

                    {previewData?.couponCode && (
                  <>
                      <div className="button-text">
                          {" "}
                          <p>
                            {" "}
                            <FontAwesomeIcon icon={faGift} /> Coupon Code{" "}
                          </p>{" "}                  
                      </div>
                   
                  </>
                )}

                {previewData?.Callbutton[0] && (
                  <>
                    {previewData.Callbutton.map((item, index) => (
                      <div className="button-text" key={index}>
                        <a href={`tel:+${item.countryCode}${item.phone}`}>
                          {" "}
                          <p>
                            {" "}
                            <FontAwesomeIcon icon={faPhone} /> {item.text}{" "}
                          </p>{" "}
                        </a>
                      </div>
                    ))}
                  </>
                )}

                {previewData?.Urlbutton[0] && (
                  <>
                    {previewData.Urlbutton.map((item, index) => (
                      <div className="button-text" key={index}>
                        <a href={`${item.url}`}>
                          {" "}
                          <p >
                            {" "}
                            <FontAwesomeIcon icon={faGlobe} /> {item.urltext}{" "}
                          </p>{" "}
                        </a>
                      </div>
                    ))}
                  </>
                )}

                {previewData?.Urlbutton2[0] && (
                  <>
                    {previewData.Urlbutton2.map((item, index) => (
                      <div className="button-text" key={index}>
                        <a href={`${item.url}`}>
                          {" "}
                          <p >
                            {" "}
                            <FontAwesomeIcon icon={faGlobe} /> {item.urltext2}{" "}
                          </p>{" "}
                        </a>
                      </div>
                    ))}
                  </>
                )}

                    {previewData.quickButton[0] && <>{quickReply()}</>}
                    {!previewData.quickButton[0] && getButtonQuickReplies().map((text, index) => (
                      <div className="button-text" key={index}>
                        <p className="mb-1">{text}</p>
                      </div>
                    ))}




              </div>
            </div>
          </div>
        </>
      )}
      {previewData && previewData.templateType === "Carousel" && (
        <div className="whatsapp-review whatsapp-bg" style={{ backgroundImage: `url(${bg_whatsapp})` }}>
          <div className="text-section">
            <div className="whats-app-header">
              <div className="">
                {" "}
                <img src={companyimg ? companyimg : whatsapp_brand} />{" "}
              </div>
              <div className="">
                {" "}
                <p>{truncatedcompanyname} </p>{" "}
              </div>
            </div>
            <div className={styles.containerWrapper}>
              <div className={styles.messageText}>
                {previewData?.bodyMessage && previewData.bodyMessage.length > 0
                  ? previewData.bodyMessage
                  : previewData?.temp_body}
              </div>

              <div className={styles.cardContainer} ref={scrollRef}>
                {previewData.cards.map((card, index) => (
                  <div className={styles.card} key={index}>
                    <img
                      src={`${card.header_image_handle}`}
                      alt="media"
                    />
                    <div className={styles.cardLabel}>{card.body_text}</div>

                    <div className={styles.cardButtons}>
                      {card.buttons.map((btn, btnIndex) => {
                        const isPhone = btn.type === "phone_number";
                        const isUrl = btn.type === "url";
                        const icon = isPhone ? faPhone : isUrl ? faGlobe : null;

                        const href = isPhone
                          ? `tel:${btn.phone_number}`
                          : isUrl
                            ? btn.url
                            : "#";

                        return (
                          <a
                            key={btnIndex}
                            href={href}
                            target={isUrl ? "_blank" : undefined}
                            rel={isUrl ? "noopener noreferrer" : undefined}
                            className={styles.replyBtn}
                            style={{ textDecoration: isUrl ? "underline" : "none", cursor: "pointer" }}
                          >
                            {icon && <FontAwesomeIcon icon={icon} />} {btn.text}
                          </a>
                        );
                      })}


                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      )}

    </div>
  );
}

export default WhatsAppPreview;
